import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card shadow-sm mb-4" }
const _hoisted_2 = { class: "card-header text-white bg-secondary fw-bold" }
const _hoisted_3 = { class: "card-content" }
const _hoisted_4 = {
  key: 0,
  class: "row m-auto"
}
const _hoisted_5 = { class: "col-12 px-5 pt-5" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "text-secondary mb-4" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "text-secondary" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-7" }
const _hoisted_15 = { class: "text-secondary" }
const _hoisted_16 = { class: "col-5" }
const _hoisted_17 = { class: "text-secondary" }
const _hoisted_18 = { class: "text-primary" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 1,
  class: "loading-area"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.status) + " Participant List", 1),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (Object.keys(_ctx.list).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (partner, key) => {
                      return (_openBlock(), _createElementBlock("div", { key: key }, [
                        _createElementVNode("h2", _hoisted_7, _toDisplayString(partner.title), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partner.list, (scenario, key) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: key,
                            class: "mb-5"
                          }, [
                            _createElementVNode("h4", null, _toDisplayString(scenario.title), 1),
                            _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
                            (key !== 'title')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scenario.participants, (participant, key) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: key,
                                      class: "mb-2 cursor-pointer text-primary"
                                    }, [
                                      (key !== 'title')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                            (_ctx.status == 'Pending')
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 0,
                                                  onClick: ($event: any) => (_ctx.router.push({name:'request',params:{request_id:participant.id}}))
                                                }, [
                                                  _createElementVNode("span", null, [
                                                    _createTextVNode(_toDisplayString(participant.user.name) + " ", 1),
                                                    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                                                    _createElementVNode("small", _hoisted_11, [
                                                      _createElementVNode("em", null, _toDisplayString(participant.user.email), 1)
                                                    ])
                                                  ]),
                                                  _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-arrow-circle-right text-primary float-end" }, null, -1))
                                                ], 8, _hoisted_10))
                                              : (_openBlock(), _createElementBlock("span", {
                                                  key: 1,
                                                  onClick: ($event: any) => (_ctx.router.push({name:'visit',params:{visit_id:participant.id}}))
                                                }, [
                                                  _createElementVNode("div", _hoisted_13, [
                                                    _createElementVNode("div", _hoisted_14, [
                                                      _createTextVNode(_toDisplayString(participant.learner.name) + " ", 1),
                                                      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                                                      _createElementVNode("small", _hoisted_15, [
                                                        _createElementVNode("em", null, _toDisplayString(participant.learner.email), 1)
                                                      ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_16, [
                                                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.moment(participant.utc_time || participant.local_time).format('MM/DD/YY')), 1),
                                                      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                                      _createElementVNode("small", _hoisted_18, [
                                                        _createTextVNode(_toDisplayString(_ctx.moment(participant.utc_time || participant.local_time).format('h:mm')), 1),
                                                        _createElementVNode("sup", null, _toDisplayString(_ctx.moment(participant.utc_time || participant.local_time).format('a')), 1)
                                                      ]),
                                                      _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-arrow-circle-right text-primary float-end" }, null, -1))
                                                    ])
                                                  ])
                                                ], 8, _hoisted_12)),
                                            _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[7] || (_cache[7] = [
                    _createElementVNode("p", { class: "text-secondary mb-5" }, "No participants at this time.", -1)
                  ])))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(_component_loading, {
              active: _ctx.loading,
              "is-full-page": false
            }, null, 8, ["active"])
          ]))
    ])
  ]))
}